<script lang="ts">
  import { PUBLIC_STRAPI_MEDIA } from '$env/static/public';
  import Lazy from 'svelte-lazy';
  import type { TwoColBannerComponent } from "$lib/js/strapi/types";

  export let component: TwoColBannerComponent
</script>


<div class="container">
  <div class="cat-banner">
    <div class="cat-banner__wrapper">
      <a class="cat-banner__img" href="/{component.link}">
        <Lazy height={380}>
          <img
            class="img-responsive"
            title="{component.title}"
            src="{PUBLIC_STRAPI_MEDIA}{component.bg_img.url}"
            height="{component.bg_img.height}"
            width="{component.bg_img.width}"
            alt="{component.title}"
          >
        </Lazy>
      </a>
      <h2><span class="thick-underline-white">{component.title}</span></h2>
    </div>
    <div class="cat-banner__wrapper">
      <a class="cat-banner__img" href="/{component.link2}">
        <Lazy height={380}>
          <img
            class="img-responsive"
            title="{component.title2}"
            src="{PUBLIC_STRAPI_MEDIA}{component.bg_img2.url}"
            alt="{component.title2}"
            height="{component.bg_img2.height}"
            width="{component.bg_img2.width}"
          >
        </Lazy>
      </a>
      <h2><span class="thick-underline-white">{component.title2}</span></h2>
    </div>
  </div>
</div>


<style lang="scss">
  .cat-banner {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @media (min-width: 769px) {
      margin-bottom: 6px;
    }

    &__wrapper {
      position: relative;
      width: 100%;

      @media (max-width: 768px) {
        margin-bottom: 6px;
      }

      @media (min-width: 769px) {
        width: calc(50% - 3px);
      }

      &:first-child {
        > h2 {
          left: 20px;
        }
      }

      &:nth-child(2) {
        > h2 {
          left: 27px;
        }
      }

      &:hover {
        > h2 {
          color: #e8e8e8;

          .thick-underline-white {
            border-color: #e8e8e8;
          }
        }
      }

      > h2 {
        position: absolute;
        bottom: 10px;
        font-weight: 700;
        color: white;
        pointer-events: none;
        transition: all linear 0.125s;
      }
    }

    &__img {
      display: flex;
      overflow: hidden;
      width: 100%;

      &:hover {
        img {
          @media (min-width: 769px) {
            transform: scale(1.05);
          }
        }
      }

      img {
        width: 100%;
        object-fit: cover;
        height: 210px;
        transition: all linear 0.15s;

        @media (min-width: 769px) {
          height: 380px;
        }
      }
    }
  }
</style>
